import { LoanPartnerCommunicationModule } from '@interhyp/module-credit-communication';
import '@interhyp/module-credit-communication/esm/index.css';
import { DocumentsModule } from '@interhyp/module-documents';

export const modules = [LoanPartnerCommunicationModule];

export const extensions = [
  ...(DocumentsModule.extensions ?? []),
  ...(LoanPartnerCommunicationModule.plugins ?? LoanPartnerCommunicationModule.extensions ?? []),
];
